import Web3 from "web3";
import toast from "react-hot-toast";
import { AbiItem } from "web3-utils";
import FerrumJson from "../../utils/abi/FerrumToken.json";
import Big from "big.js";

export const performSwitchNetwork = async (networkId: any) => {
  try {
    let ethereum = (window as any).ethereum;
    if (ethereum) {
      const hexChainId = Number(networkId).toString(16);
      await ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: `0x${hexChainId}` }],
      });
    }
  } catch (err: any) {
    toast.error(err?.message);
  }
};

export const addNetworkToMetamask = async (item: any) => {
  const { ethereum } = window as any;
  try {
    await ethereum.request({
      method: "wallet_addEthereumChain",
      params: [item],
    });
  } catch (err: any) {
    toast.error(err?.message);
  }
};

export class Web3Helper {
  web3Client: Web3;

  constructor(web3: Web3 | any) {
    this.web3Client = web3;
  }

  async sendSwapTransactionAsync(payload: any, dispatch?: any) {
    return new Promise((resolve, reject) => {
      this.web3Client.eth
        .sendTransaction(payload)
        .on("transactionHash", (transactionHash) => {
          console.log("transactionHash", transactionHash);
          if (transactionHash) {
            console.log({ transactionHash });
            resolve(transactionHash);
          }
        })
        .on("receipt", (receipt) => {
          if (receipt.transactionHash) {
            console.log("receipt", receipt);
          }
        })
        .then((data: any) => {
          if (data && data.transactionHash) {
            console.log("swap completed::", data);
          }
        })
        .catch((e: any) => {
          if (dispatch) {
            dispatch(e);
          }
          console.log("failed", e);
          reject(e);
        });
    });
  }

  async fetchNativeTokenBalance(walletAddress: string) {
    try {
      let balance = await this.web3Client.eth.getBalance(walletAddress);
      balance = this.web3Client.utils.fromWei(balance, "ether");
      return balance;
    } catch (e) {
      console.log("fetch Native Token Balance error", e);
    }
  }

  async fetchTokenBalance(tokenAddress: string, walletAddress: string) {
    try {
      const tokenContract = new this.web3Client.eth.Contract(
        FerrumJson.abi as AbiItem[],
        tokenAddress
      );
      let balance = await tokenContract.methods.balanceOf(walletAddress).call();
      let dec = await tokenContract.methods.decimals().call();
      const decimalFactor = 10 ** Number(dec);
      balance = new Big(balance).div(decimalFactor).toFixed(Number(dec));
      return balance;
    } catch (e) {
      console.log("fetch Token Balance error", e);
    }
  }

  async fetchTokenDetail(tokenAddress: string) {
    try {
      const tokenData: any = {
        tokenAddress: tokenAddress,
      };
      const tokenContract = new this.web3Client.eth.Contract(
        FerrumJson.abi as AbiItem[],
        tokenAddress
      );
      const [symbol, decimals, name] = await Promise.all([
        tokenContract.methods.symbol().call(),
        tokenContract.methods.decimals().call(),
        tokenContract.methods.name().call(),
      ]);
      tokenData.decimals = decimals;
      tokenData.name = name;
      tokenData.symbol = symbol;
      console.log("tokenData", tokenData);
      return tokenData;
    } catch (e) {
      console.log("error", e);
    }
  }
}
